import React, { useState } from "react";
import { TextField, Typography, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Formik } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import CircularProgress from "@mui/material/CircularProgress";
import SubmitButton from "../../../components/SubmitButton";

const useStyles = makeStyles((theme) => ({
  root: {
    "@media (max-width: 600px)": {
      padding: "10px 2%",
    },
  },
  inputElt: {
    padding: "10px 0",
    width: "100%",
    display: "grid",
  },
  groupInputElt: {
    padding: "10px 0",
    display: "grid",
    gridGap: "10px",
    gridTemplateColumns: "repeat(2,1fr)",

    "@media (max-width: 600px)": {
      gridTemplateColumns: "repeat(1,1fr)",
      padding: "5px 0",
    },
  },
  selectTitle: {
    color: "grey",
  },
  errorMsg: {
    color: "red",
  },
}));

export default ({
  message = "",
  onPaymentSubmit,
  loading = false,
  error,
  completed,
}) => {
  const classes = useStyles();

  const [state, setState] = useState({});

  const onPhoneChange = (phone) => {
    setState({
      ...state,
      phoneNumber: phone,
      formError: "",
    });
  };

    const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  }

  return (
    <Box className={classes.root}>
      {completed && !error ? (
        <Box
          style={{
            textAlign: "center",
            width: "100%",
          }}
        >
          <Typography variant="subtitle1">
            Your payment is being processed, we will notify you once done.
          </Typography>
          <CircularProgress
            style={{
              display: "inline-block",
              padding: 30,
              color: "#1876D1",
            }}
          />
        </Box>
      ) : (
        <>
          {state.formError || error ? (
            <Typography className={classes.errorMsg} variant="subtitle1">
              {state.formError || (error && message)}
            </Typography>
          ) : (
            <Typography variant="subtitle1">{message}</Typography>
          )}
          <Formik initialValues={{...initialValues}}
          validationSchema={Yup.object().shape({
          firstName: Yup.string().trim().required("first Name is required"),
          lastName: Yup.string().trim().required("last Name is required"),
          email: Yup.string().trim().email('please proviide a valid email').required("email is required"),
        })}
        onSubmit={(values)=>{
          if (!state.phoneNumber || state.phoneNumber.length < 12) {
            return setState({
              ...state,
              formError: "Please enter correct phone number"
            });
          }
          return onPaymentSubmit({
            firstName: values.firstName.trim(),
            lastName: values.lastName.trim(),
            email: values.email.trim(),
            phoneNumber: state.phoneNumber.replaceAll(/\s/g, ''),
            //  pass you customer information.
          })
        }}
        >
          {({
            errors, handleBlur, handleChange, handleSubmit, touched, values
          }) =>(
            <Box
            component="form"
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <Box sx={{
              '& > :not(style)': { m: 1},
            }}>
              <TextField id="outlined-basic" error={Boolean(touched.firstName && errors.firstName)} helperText={touched.firstName && errors.firstName} name="firstName" required onBlur={handleBlur} value={values.firstName.trim()}
                onChange={handleChange}  type="text" label="First Name" variant="outlined" sx={{width:"100%", margin:"0px 10px"}}/>
              <TextField id="filled-basic" required value={values.lastName.trim()} error={Boolean(touched.lastName && errors.lastName)} helperText={touched.lastName && errors.lastName}  name="lastName" label="lastName" onBlur={handleBlur}
                onChange={handleChange} type="text" variant="outlined" sx={{width:"100%", margin:"0px 10px"}} />
              <TextField id="standard-basic" type="email" error={Boolean(touched.email && errors.email)} helperText={touched.email && errors.email} value={values.email.trim()} sx={{width:"100%", margin:"0px 10px"}}  name="email" onBlur={handleBlur}
              onChange={handleChange} label="Email" required variant="outlined" />
              <PhoneInput
                country={"rw"}
                className={classes.inputElt}
                value={values.phoneNumber.trim()}
                onChange={onPhoneChange}
                inputStyle={{ width: "100%" }}
              />
            </Box>
            <Box sx={{width:"100%", display:"flex", justifyContent:"center", margin:"10px 0px"}}>
              <SubmitButton sx={{
                padding: "15px 0",
                width: "50%",
                backgroundColor: "#1876D1",
                color: "white",
                display: "inline",
                "&:hover": {
                  background: "#1876D1",
                  cursor: "pointer",
                },

                "@media (max-width: 600px)": {
                  padding: "10px 0",
                  width: "100%",
                },
              }} type="submit" disabled={loading} loading={loading}>Proceed With Payment</SubmitButton>
            </Box>
            
        </Box>
          )}
        </Formik>
        </>
      )}
    </Box>
  );
};
